import React from "react";
import {
  ResponsiveContainer,
  AreaChart as ReAreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

/**
 * Minimal area chart — good for volume / collection trends.
 * data: [{ period, value }] or custom dataKey
 */
const AreaChart = ({
  data = [],
  height = 200,
  dataKey = "value",
  xKey = "period",
  color = "#0D9488",
  fillOpacity = 0.15,
}) => {
  if (!data?.length) {
    return (
      <div
        className="flex items-center justify-center text-xs text-slate-400 dark:text-neutral-500"
        style={{ height }}
      >
        No data
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <ReAreaChart
          data={data}
          margin={{ top: 4, right: 8, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id={`areaFill-${color.replace("#", "")}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.35} />
              <stop offset="100%" stopColor={color} stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
          <XAxis
            dataKey={xKey}
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#94a3b8" }}
            axisLine={false}
            tickLine={false}
            width={48}
          />
          <Tooltip
            contentStyle={{
              fontSize: 12,
              borderRadius: 6,
              border: "1px solid #e2e8f0",
              boxShadow: "none",
            }}
            formatter={(v) =>
              typeof v === "number"
                ? v.toLocaleString("en-IN", { maximumFractionDigits: 0 })
                : v
            }
          />
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke={color}
            strokeWidth={2}
            fill={`url(#areaFill-${color.replace("#", "")})`}
            fillOpacity={1}
            animationDuration={400}
          />
        </ReAreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AreaChart;
